import { decryptContent, encryptContent } from "@/lib/transform";

export function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export class Storage {
  static getItem(item) {
    const value = localStorage.getItem(item);
    if (value === undefined || value === null) {
      return null;
    }
    try {
      const decryptedValue = decryptContent(value);
      const parsedValue = IsJsonString(decryptedValue)
        ? JSON.parse(decryptedValue)
        : decryptedValue;
      return parsedValue;
    } catch (error) {
      console.log(error);
    }
    return value;
  }

  static setItem(item, itemValue) {
    try {
      let value = itemValue;
      if (typeof itemValue === "object" && itemValue !== null) {
        value = JSON.stringify(itemValue);
      }
      localStorage.setItem(item, encryptContent(value));
    } catch (error) {
      console.log(error);
    }
  }

  static removeItem(item) {
    try {
      localStorage.removeItem(item);
    } catch (error) {
      console.log(error);
    }
  }
  static removeAllItems() {
    try {
      localStorage.clear();
    } catch (error) {
      console.log(error);
    }
  }

  static checkAuthentication() {
    let userToken;
    try {
      userToken = Storage.getItem("TreasuraAdminUserToken");
    } catch (error) {
      console.log(error);
      return false;
    }
    return userToken;
  }
}
